import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import { Routine, RoutineParams } from 'src/app/models/Routine';
import { SaveRoutine } from './routine.actions';

export interface RoutineStateModel {
    routine: RoutineParams[];
}

@State<RoutineStateModel>({
    name: 'routine',
    defaults: {
        routine: []
    }
})
@Injectable()
export class RoutineState {
    @Action(SaveRoutine)
    saveRoutine(ctx: StateContext<RoutineStateModel>, action: SaveRoutine) {
        const state = ctx.getState();
        ctx.patchState({
            routine: [
                action.routine,
            ]
        });
    }
}